import React from "react";
import purpleNetworkBg from "@/assets/auraxp-purple-network-bg.jpg";

const TransformingSecuritySection = () => {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src={purpleNetworkBg} 
          alt="" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/20" />
      </div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-5xl mx-auto space-y-8">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white">
            Transforming Security Operations into Autonomous Intelligence
          </h2>
          <p className="text-lg text-white/90 leading-relaxed">
            AuraXP by Spharaka Networks goes beyond reactive security. It is an AI-powered Cyber Brain that understands behaviors, predicts threats, and orchestrates real-time responses, mirroring the decision-making of a top-tier analyst at machine speed and scale. By connecting every part of your infrastructure; endpoints, networks, cloud environments, and identities; AuraXP becomes your organizational memory for security. When people leave, the intelligence doesn't. AuraXP continuously learns, adapts, and evolves, ensuring your defense fabric grows smarter every day.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TransformingSecuritySection;
